import Send from "@mui/icons-material/Send";
import { Button, Stack } from "@mui/material";
import { SaveAndPrepareForSigningButton } from "components/Submission/SaveAndPrepareForSigningButton";
import { getMoveButtonLabel } from "components/Submission/UpdateSubmissionStatusButton";
import {
  DocumentType,
  Issue,
  SubmissionDocumentType,
  SubmissionStepType,
} from "generated-graphql/graphql";
import { useStepperNavigation } from "hooks/useStepperNavigation";
import { SubmissionReviewerSigner } from "hooks/useSubmissionForm";

type PrepareDocument = {
  id: string;
  name: string;
  documentType: DocumentType;
  submissionDocumentType: SubmissionDocumentType;
  url?: string;
  fileExtension?: string | null;
};

export function ReviewerPreparationActions({
  saving,
  sending,
  hasUnsavedChanges,
  onSaveConfig,
  showPrepareForSigning,
  signer,
  displayIssues,
  documents,
  onPrepareForSigning,
  showSendForReview,
  sendDisabled,
  onSend,
  isStaff,
  advancesWithoutReview,
}: {
  saving: boolean;
  sending: boolean;
  hasUnsavedChanges: boolean;
  onSaveConfig: () => void;
  showPrepareForSigning: boolean;
  signer: SubmissionReviewerSigner | null;
  displayIssues: Issue[];
  documents: PrepareDocument[];
  onPrepareForSigning: () => void;
  showSendForReview: boolean;
  sendDisabled: boolean;
  onSend: () => void;
  isStaff: boolean;
  advancesWithoutReview: boolean;
}) {
  const { goToPreviousStep } = useStepperNavigation();

  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <Button
        variant="text"
        disabled={saving || sending}
        onClick={() => goToPreviousStep(SubmissionStepType.ReviewerPreparation)}
      >
        Back
      </Button>
      <Button
        variant="outlined"
        loading={saving}
        disabled={!hasUnsavedChanges || sending}
        onClick={onSaveConfig}
      >
        Save
      </Button>
      {showPrepareForSigning && (
        <SaveAndPrepareForSigningButton
          signer={signer}
          issues={displayIssues}
          documents={documents}
          loading={saving}
          formLoading={false}
          isSubmitting={saving}
          isValidating={false}
          onClick={onPrepareForSigning}
        />
      )}
      {showSendForReview && (
        <Button
          variant="contained"
          loading={sending || saving}
          disabled={sendDisabled}
          endIcon={<Send />}
          onClick={onSend}
        >
          {getMoveButtonLabel({ advancesWithoutReview, isStaff })}
        </Button>
      )}
    </Stack>
  );
}
